import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useState } from 'react';
import { StandardButton } from '@eika/button';
import { ConfirmCountryResponseType } from '../generated-types';
import ErrorMessage from './error-message';
import OverlayLoader from './overlay-loader';
const CountryRelations = _ref => {
  let {
    countrySection,
    confirmedCountries,
    onSubmit,
    confirmCountries
  } = _ref;
  const {
    countryOfBirth,
    countryOfResidence,
    citizenship,
    mainQuestion
  } = countrySection;
  const responsibilityTextPart1 = mainQuestion || 'Du er ansvarlig for at informasjonen i skjemaet er riktig og at du ikke unnlater viktig informasjon. Informasjon om land og statsborgerskap er hentet fra Folkeregisteret.';
  const responsibilityTextPart2 = 'Om du ser at denne informasjonen ikke stemmer må du kontakte banken.';
  const tryAgainText = 'Vennligst prøv å bekrefte igjen. Dersom problemet vedvarer må du kontakte banken';
  const [countriesNotVerified, setCountriesNotVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (confirmedCountries.loaded) {
      setLoading(false);
      switch (confirmedCountries.response.typeInfo) {
        case ConfirmCountryResponseType.OK:
          onSubmit();
          break;
        case ConfirmCountryResponseType.NOT_VALID:
          //        TODO: Figure out what to do
          break;
        case ConfirmCountryResponseType.NOT_VERIFIED:
        case ConfirmCountryResponseType.ERROR:
          setCountriesNotVerified(true);
          break;
        default:
          break;
      }
    }
  }, [confirmedCountries, onSubmit]);
  const confirm = () => {
    setLoading(true);
    confirmCountries({
      countryOfBirth: countrySection.countryOfBirth,
      countryOfResidence: countrySection.countryOfResidence,
      citizenship: countrySection.citizenship
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(OverlayLoader, null) : undefined, /*#__PURE__*/React.createElement("div", null, responsibilityTextPart1, /*#__PURE__*/React.createElement("br", null), responsibilityTextPart2), /*#__PURE__*/React.createElement("h2", {
    className: "form-question"
  }, "Statsborgerskap"), /*#__PURE__*/React.createElement("span", null, citizenship === null || citizenship === void 0 ? void 0 : citizenship.map((country, index) => "".concat(country.text).concat(index < citizenship.length - 1 ? ', ' : ''))), countryOfBirth && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "form-question"
  }, "F\xF8deland"), /*#__PURE__*/React.createElement("span", null, countryOfBirth.text)), countryOfResidence && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "form-question"
  }, "Bostedsland"), /*#__PURE__*/React.createElement("span", null, countryOfResidence.text)), countriesNotVerified ? /*#__PURE__*/React.createElement("div", {
    className: "form-question"
  }, /*#__PURE__*/React.createElement(ErrorMessage, {
    text: tryAgainText
  })) : undefined, /*#__PURE__*/React.createElement(StandardButton, {
    className: "progress-next-button",
    onClick: confirm
  }, "Bekreft"));
};
export default CountryRelations;